<h1>{{ "歡迎加入 1Campus！" | i18next }}</h1>
